import React from 'react';
import {FaWhatsapp} from "react-icons/fa";
import {Link} from "react-router-dom";

function SquareWhatsAppButton(props) {
    return (
        <a href="https://wa.me/353861800820" target="_blank">
            <button className='btn btn-square bg-success text-white d-inline-flex align-items-center justify-content-center'>
                <FaWhatsapp/>
            </button>
        </a>
    );
}

export default SquareWhatsAppButton;